/**
 * Generated by orval 🍺
 * Do not edit manually.
 * FastAPI
 * OpenAPI spec version: 0.1.0
 */
import type { LecturerEvaluationUpdateRequestEvaluation } from './lecturerEvaluationUpdateRequestEvaluation';
import type { LecturerEvaluationUpdateRequestFeedback } from './lecturerEvaluationUpdateRequestFeedback';

/**
 * Update request for lecturer evaluation and/or feedback
 */
export interface LecturerEvaluationUpdateRequest {
  evaluation?: LecturerEvaluationUpdateRequestEvaluation;
  feedback?: LecturerEvaluationUpdateRequestFeedback;
}
